import { Navigate, useRoutes } from 'react-router-dom';
// layouts
// import MainLayout from 'src/layouts/main';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
import { useAuthContext } from 'src/auth/hooks';
//
import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';
import { userdashboardRoutes } from './userdashboard';
import { paths } from '../paths';

// ----------------------------------------------------------------------

export default function Router() {

  const { user } = useAuthContext();

  const PATH = paths.auth.jwt.login;

  const adminRoutes = useRoutes(
    [
      // SET INDEX PAGE WITH SKIP HOME PAGE
      {
        path: '/',
        // element: <Navigate to={PATH_AFTER_LOGIN} />,
        element: <Navigate to={PATH} />,
      },

      // ----------------------------------------------------------------------

      // SET INDEX PAGE WITH HOME PAGE
      // {
      //   path: '/',
      //   element: (
      //     <MainLayout>
      //       <HomePage />
      //     </MainLayout>
      //   ),
      // },

      // Auth routes
      ...authRoutes,
      ...authDemoRoutes,

      // Dashboard routes
      ...dashboardRoutes,

      // User Dashboard
      ...userdashboardRoutes,

      // Main routes
      ...mainRoutes,

      // Components routes
      ...componentsRoutes,

      // No match 404
      { path: '*', element: <Navigate to="/404" replace /> },
    ]
  )

  const workerRoutes = useRoutes(
    [
      // SET INDEX PAGE WITH SKIP HOME PAGE
      {
        path: '/',
        // element: <Navigate to={PATH_AFTER_LOGIN} />,
        element: <Navigate to={PATH} />,
      },

      // ----------------------------------------------------------------------

      // SET INDEX PAGE WITH HOME PAGE
      // {
      //   path: '/',
      //   element: (
      //     <MainLayout>
      //       <HomePage />
      //     </MainLayout>
      //   ),
      // },

      // Auth routes
      ...authRoutes,
      ...authDemoRoutes,

      // Dashboard routes
      ...userdashboardRoutes,

      // Main routes
      ...mainRoutes,

      // Components routes
      ...componentsRoutes,

      // No match 404
      { path: '*', element: <Navigate to="/404" replace /> },
    ]
  )

  // return useRoutes([
  //   // SET INDEX PAGE WITH SKIP HOME PAGE
  //   {
  //     path: '/',
  //     // element: <Navigate to={PATH_AFTER_LOGIN} />,
  //     element: <Navigate to={PATH} />,
  //   },

  //   // ----------------------------------------------------------------------

  //   // SET INDEX PAGE WITH HOME PAGE
  //   // {
  //   //   path: '/',
  //   //   element: (
  //   //     <MainLayout>
  //   //       <HomePage />
  //   //     </MainLayout>
  //   //   ),
  //   // },

  //   // Auth routes
  //   ...authRoutes,
  //   ...authDemoRoutes,

  //   // Dashboard routes
  //   ...dashboardRoutes,

  //   // Main routes
  //   ...mainRoutes,

  //   // Components routes
  //   ...componentsRoutes,

  //   // USER/WORKER ROUTES
  //   ...userdashboardRoutes,

  //   // No match 404
  //   { path: '*', element: <Navigate to="/404" replace /> },
  // ]);

  return (user?.role === "Admin") ? adminRoutes : workerRoutes;
}
